// Map hotspot/media ID -> FontAwesome icon object (free-solid)
// Icon objects import trực tiếp từ @fortawesome/free-solid-svg-icons
// Tra cứu icon: https://fontawesome.com/search?o=r&m=free&s=solid
import {
  faTrainSubway,
  faBusSimple,
  faPlane,
  faBuildingColumns,
  faShop,
  faWater,
  faHospital,
  faHospitalUser,
  faSchool,
  faSchoolFlag,
  faGraduationCap,
  faBasketShopping,
  faStore,
  faBagShopping,
  faCartShopping,
  faGolfBallTee,
  faTicketSimple,
  faMonument,
  faPlaneDeparture,
  faTree,
  faLocationDot,
  faMicrochip,
  faAnchor,
  faIndustry,
} from '@fortawesome/free-solid-svg-icons';

export const TRAVEL_TIMES = {
  // '690b2ebafbeb572cfafcfb24': '25 phút',
  '690b2e80fbeb572cfafcfaf6': '15 phút',
  // '690b2fd1fbeb572cfafcfc34': '30 phút',
  '690b2e51fbeb572cfafcfac5': '20 phút',
  '690b2f34fbeb572cfafcfb85': '10 phút',

  //
  '6a02c6bd47b0fda4964326f8': '3 phút', // Metro Bến Xe Suối Tiên
  '6a02dcf447b0fda4964384d7': '9 phút', // Bến Xe Miền Đông Mới
  // Sức khoẻ
  '6a02dd0647b0fda496438550': '10 phút', // Bệnh Viện Đa Khoa Quốc Tế Hoàn Mỹ
  '6a02dd1647b0fda4964385b7': '5 phút', // Bệnh Viện Ung Bướu CS2
  // Mua sắm & Giải Trí
  '6a02dd2847b0fda49643861a': '9 phút', // TTTM Go! Dĩ An
  '6a02dd4447b0fda4964386de': '19 phút', // Vincom Thủ Đức
  '6a02dd5447b0fda496438761': '18 phút', // Vincom Plaza Lê Văn Việt
  '6a02dd6347b0fda4964387bc': '15 phút', // Vincom Mega Mall
  '6a02dd7f47b0fda49643887c': '13 phút', // Công viên Văn hoá Suối Tiên
  '6a02dd8f47b0fda4964388e9': '14 phút', // Sân Golf Thủ Đức
  // Hệ sinh thái mặt nước
  '6a02dd9d47b0fda496438936': '3 phút', // Hồ Đá
  '6a02ddaf47b0fda496438988': '3 phút', // Hồ Bình An
  // Giáo dục
  '6a02ddc947b0fda496438a5f': '6 phút', // Trường Tiểu học Đông Hoà B
  '6a02ddda47b0fda496438ad0': '8 phút', // Trường THCS Đông Hoà
  '6a02dde847b0fda496438b37': '15 phút', // Trường THPT Dĩ An
  '6a02ddf547b0fda496438bbb': '14 phút', // Trường THPT Linh Trung
  // Node mở rộng - Hệ sinh thái tri thức & công nghệ
  '6a02dea147b0fda4964390ac': '1 phút', // Hệ thống Trường đại học Quốc Gia
  '6a02deae47b0fda496439114': '17 phút', // Khu Công Nghệ Cao
  // Khác
  '6a02dec847b0fda4964391f8': '10 phút', // Công viên Văn Hoá Lịch Sử Dân Tộc (403ha)
  '6a02ded747b0fda496439269': '1 giờ 15 phút', // Sân Bay Quốc tế Long Thành
  '6a02dee747b0fda496439303': '25 phút', // Trung tâm hành chính Thủ Thiêm
  '6a02def847b0fda49643938c': '25 phút', // Chợ Bến Thành (đại điện cho Quận 1)
  '6a15178228a9d9dbfa9f6946': '30 phút', // Sân bay Tân Sơn Nhất
  // "6a151a6728a9d9dbfa9f8f98": "10 phút", // Công viên ven hồ Bình An
};

// These hotspots will always be visible regardless of filter selection
export const ALWAYS_VISIBLE_HOTSPOT_IDS = [
  '68d12769ddcbe92b6b39ad9e', // NEWSTAR
  '6a1542e528a9d9dbfaa0e5c1',
  '6a1542ff28a9d9dbfaa0e6af',
];

// Render order: index càng thấp = render trước = nằm dưới
// Muốn hotspot nào trên thì để index cao hơn
export const HOTSPOT_RENDER_ORDER = [
  // VD: Metro bến xe suối tiên nằm dưới Bến xe miền đông
  '6a02dcf447b0fda4964384d7', // Bến Xe Miền Đông Mới
  '6a02ded747b0fda496439269', // Sân Bay Quốc tế Long Thành
  '6a02dd5447b0fda496438761', // Vincom Plaza Lê Văn Việt
  '6a6c4da5c6222a78db0fac47', // Khu công nghệ cao
  '6a02dd1647b0fda4964385b7', // Bệnh Viện Ung Bướu CS2
  '6a02c6bd47b0fda4964326f8', // Metro Bến Xe Suối Tiên
  '6a02dd2847b0fda49643861a', // TTTM Go! Dĩ An

  '6a02dd0647b0fda496438550', // Bệnh Viện Đa Khoa Quốc Tế Hoàn Mỹ
  '6a02dd6347b0fda4964387bc', // Vincom Mega Mall Thảo Điền
  '6a02def847b0fda49643938c', // Chợ Bến Thành

  '6a02dd8f47b0fda4964388e9', // Sân Golf Thủ Đức
  // '6a02dd9d47b0fda496438936', // Hồ Đá
  '6a02ddaf47b0fda496438988', // Hồ Bình An
  '6a02ddc947b0fda496438a5f', // Trường Tiểu học Đông Hoà B
  '6a02ddda47b0fda496438ad0', // Trường THCS Đông Hoà
  '6a02dde847b0fda496438b37', // Trường THPT Dĩ An
  '6a02ddf547b0fda496438bbb', // Trường THPT Linh Trung
  '6a02dea147b0fda4964390ac', // Hệ thống Trường đại học Quốc Gia
  '6a02deae47b0fda496439114', // Khu Công Nghệ Cao
  '6a02dec847b0fda4964391f8', // Công viên Văn Hoá Lịch Sử Dân Tộc
  '6a02dee747b0fda496439303', // Trung tâm hành chính Thủ Thiêm
  '6a15178228a9d9dbfa9f6946', // Sân bay Tân Sơn Nhất
  // '690b2e80fbeb572cfafcfaf6', // Công viên Văn hoá Suối Tiên
  '6a38ab03163b8b61734dd3e1', // Ho Da
  '6a38ab52163b8b61734dd437', // Công viên Văn hoá Suối Tiên
  '6a02dd4447b0fda4964386de', // Vincom Thủ Đức
];

// Rotated diagonal hotspot configs: { angle, offsetX, offsetY }
export const ROTATED_DIAGONAL_CONFIGS = {
  // constant angle configs: 45, 135, 180, 225, 270, 315
  // '6a02dd6347b0fda4964387bc': { angle: 315, offsetX: -137, offsetY: -2 },
  // '6a02dd0647b0fda496438550': { angle: 45, offsetX: 0, offsetY: -30 },
  // '690b2e80fbeb572cfafcfaf6': { angle: 225, offsetX: 13, offsetY: 13 },
  // '6a02dee747b0fda496439303': { angle: 225, offsetX: -30, offsetY: 0 },
};

// Map hotspot/media ID -> FontAwesome icon
export const MEDIA_HOTSPOT_ICONS = {
  // Di chuyển
  '6a02c6bd47b0fda4964326f8': faTrainSubway, // Metro Bến Xe Suối Tiên
  '6a02dcf447b0fda4964384d7': faBusSimple, // Bến Xe Miền Đông Mới
  '6a02ded747b0fda496439269': faPlane, // Sân Bay Quốc tế Long Thành
  '6a02dee747b0fda496439303': faBuildingColumns, // Trung tâm hành chính Thủ Thiêm
  '6a02def847b0fda49643938c': faShop, // Chợ Bến Thành

  // Hệ sinh thái mặt nước
  '6a38ab03163b8b61734dd3e1': faWater, // Hồ Đá
  '6a38ab93163b8b61734dd47d': faWater, // Hồ Bình An

  // Sức khỏe
  '6a02dd0647b0fda496438550': faHospital, // Bệnh Viện Đa Khoa Quốc Tế Hoàn Mỹ
  '6a02dd1647b0fda4964385b7': faHospitalUser, // Bệnh Viện Ung Bướu CS2

  // Giáo dục
  '6a02ddc947b0fda496438a5f': faSchool, // Trường Tiểu học Đông Hoà B
  '6a02ddda47b0fda496438ad0': faSchool, // Trường THCS Đông Hoà
  '6a02dde847b0fda496438b37': faSchoolFlag, // Trường THPT Dĩ An
  '6a02ddf547b0fda496438bbb': faSchoolFlag, // Trường THPT Linh Trung
  '6a02dea147b0fda4964390ac': faGraduationCap, // Hệ thống Trường ĐH Quốc Gia

  // Mua sắm & Giải trí
  '6a02dd2847b0fda49643861a': faBasketShopping, // TTTM Go! Dĩ An
  '6a02dd4447b0fda4964386de': faStore, // Vincom Thủ Đức
  '6a02dd5447b0fda496438761': faBagShopping, // Vincom Plaza Lê Văn Việt
  '6a02dd6347b0fda4964387bc': faCartShopping, // Vincom Mega Mall Thảo Điền
  '6a02dd8f47b0fda4964388e9': faGolfBallTee, // Sân Golf Thủ Đức
  '6a38aab7163b8b61734dd373': faStore, // Chợ Đông Hòa
  '6a38ab52163b8b61734dd437': faTicketSimple, // KDL Suối Tiên
  '6a02dec847b0fda4964391f8': faMonument, // Công viên Văn Hoá Lịch Sử Dân Tộc

  // Khác
  '6a15178228a9d9dbfa9f6946': faPlaneDeparture, // Sân bay Tân Sơn Nhất
  '6a151a6728a9d9dbfa9f8f98': faTree, // Công viên ven hồ Bình An
  '690b2e51fbeb572cfafcfac5': faHospital, // Bệnh Viện Thủ Đức
  '68d12769ddcbe92b6b39ad9e': faLocationDot, // NEWSTAR main hotspot
  '6a6c4da5c6222a78db0fac47': faMicrochip, //Khu công nghệ cao
  '6a6c4e9ac6222a78db0fad0c': faAnchor, //Cụm cảng sông đồng nai
  '6a6c4ef7c6222a78db0fad56': faIndustry, //Khu công nghiệp sóng thần
  '6a6c4f3ac6222a78db0fad92': faIndustry, //Khu cộng nghiệp linh trung
};

export const getMediaHotspotIcon = (mediaId) => {
  return MEDIA_HOTSPOT_ICONS[mediaId] || null;
};

// Control where hotspot titles break into a second line by media id.
// Value = number of leading words to keep on the first line.
export const SPECIAL_TITLE_SPLIT_IDS = {
  '6a02ddc947b0fda496438a5f': 3, // Trường Tiểu học Đông Hoà B
  '6a02dee747b0fda496439303': 4, // Trung tâm hành chính Thủ Thiêm
  '6a02ded747b0fda496439269': 4, // Sân Bay Quốc tế Long Thành
  '6a38ab52163b8b61734dd437': 4, // Công viên Văn hoá Suối Tiên
  '6a151a6728a9d9dbfa9f8f98': 3, // Công viên ven hồ Bình An
};

export const splitHotspotTitle = (title = '', mediaId) => {
  const words = title.split(' ');
  const splitIndex = SPECIAL_TITLE_SPLIT_IDS[mediaId] ?? 5;
  return {
    firstLine: words.slice(0, splitIndex).join(' '),
    secondLine:
      words.length > splitIndex ? words.slice(splitIndex).join(' ') : '',
  };
};
